import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
// import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

void i18n
    .use(Backend)
    //   .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: true,

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
